import { useState } from 'react';
import { ScrollText } from 'lucide-react';
import { Button } from '../components/ui/button';
import { CharteContent } from '../pages/CharteUtilisation';
import axios from 'axios';
import { toast } from 'sonner';

const CharteModal = ({ onAccept }) => {
  const [accepted, setAccepted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleAccept = async () => {
    setLoading(true);
    try {
      await axios.post('/auth/accept-charte');
      toast.success('Charte acceptée');
      onAccept();
    } catch (error) {
      toast.error("Erreur lors de l'acceptation de la charte");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[100] bg-black/60 flex items-center justify-center p-4" data-testid="charte-modal">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[90vh] flex flex-col">
        <div className="p-5 border-b border-slate-200 flex items-center gap-3 flex-shrink-0">
          <div className="w-10 h-10 bg-[#8DC63F]/10 rounded-full flex items-center justify-center">
            <ScrollText className="h-5 w-5 text-[#8DC63F]" />
          </div>
          <div>
            <h2 className="text-lg font-bold text-[#0F172A]">Charte d'utilisation</h2>
            <p className="text-xs text-slate-500">Veuillez lire et accepter la charte pour continuer</p>
          </div>
        </div>

        <div className="flex-1 overflow-y-auto p-5">
          <CharteContent />
        </div>

        <div className="p-5 border-t border-slate-200 flex-shrink-0 space-y-3">
          <label className="flex items-start gap-3 cursor-pointer" data-testid="charte-checkbox-label">
            <input
              type="checkbox"
              checked={accepted}
              onChange={(e) => setAccepted(e.target.checked)}
              className="mt-0.5 h-5 w-5 rounded border-slate-300 text-[#8DC63F] focus:ring-[#8DC63F]"
              data-testid="charte-checkbox"
            />
            <span className="text-sm text-slate-700">
              J'ai lu et j'accepte la <strong>charte d'utilisation</strong> de la plateforme FISL
            </span>
          </label>
          <Button
            onClick={handleAccept}
            disabled={!accepted || loading}
            className="w-full bg-[#8DC63F] hover:bg-[#7AB62F] text-white h-11 font-semibold disabled:opacity-50"
            data-testid="charte-accept-btn"
          >
            {loading ? 'Validation...' : 'Accepter et continuer'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CharteModal;
